import { useMutation, useQueryClient } from '@tanstack/react-query';

import { importFromPos } from '../../../../store/Restaurant/api';

export const useImportFromPost = () => {
    const queryClient = useQueryClient();

    return useMutation(['import-from-pos'], () => importFromPos(), {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['menu-list']);
        },
    });
};
